import { type IUserDetails } from 'interfaces/user';
import apiService from 'services/api';
import authSessionService from 'services/authSession';
import { ACCOUNT_ENV } from 'settings';

import {
  type HyperflowToken,
  type LoginAsEmail,
  type SendHelpRequest,
  type SupportChatToken,
  type User
} from './types';

export class UserService {
  public getUser(): User | null {
    return authSessionService.getSession().user;
  }

  public setUser(user: User): User {
    return authSessionService.setUser(user) as User;
  }

  public logout(): void {
    authSessionService.clearSession();
    localStorage.clear();
    sessionStorage.clear();
    (window as any).Eduzz.Accounts.logout({
      ...ACCOUNT_ENV,
      redirectTo: window.location.origin
    });
  }

  public setMeAsProducer(data: any): Promise<any> {
    return apiService.post('/user/set_as_producer', data);
  }

  public hasUsedTour(data: any): Promise<any> {
    return apiService.put('/user/tour', data);
  }

  public loginByEventHash(data: any): Promise<any> {
    return apiService.post('/auth/loginbyeventhash', data).then(res => res.data[0]);
  }

  public loginAs(data: any): Promise<User> {
    return apiService.post('/user/login_as', data).then(res => res.data[0]);
  }

  public sendHelp(helpData: SendHelpRequest): Promise<any> {
    const { eventId, ...data } = helpData;
    return apiService.post(`help_services/helpsend/${eventId}`, data);
  }

  public loginAsEmail(email: string): Promise<LoginAsEmail> {
    return apiService.post('/user/acpo_login_as', { email }).then(res => res.data[0]);
  }

  public getDetails(): Promise<IUserDetails> {
    return apiService.get('/user/details').then(res => res.data);
  }

  public createSupportChatToken(ssid): Promise<SupportChatToken> {
    return apiService.post('/user/support-chat/create-token', { ssid });
  }

  public createHyperflowToken(userToHyperflow): Promise<HyperflowToken> {
    return apiService.post('/user/support-chat/create-hyperflow-token', { userToHyperflow });
  }

  public getBeltById(id: number): string {
    const belts = {
      100: 'Red Belt',
      101: 'Orange Belt',
      102: 'Green Belt',
      103: 'Black Belt',
      104: 'Golden Belt',
      109: 'Black Belt D2',
      110: 'Black Belt D3',
      111: 'Black Belt D4',
      112: 'Black Belt D5',
      113: 'Black Belt D6',
      114: 'Black Belt D7',
      115: 'Black Belt D8',
      116: 'Black Belt D9',
      300: 'Sensei',
      302: 'Golden Belt D20',
      303: 'Golden Belt D30',
      304: 'Golden Belt D40',
      305: 'Golden Belt D50',
      306: 'Golden Belt D60',
      307: 'Golden Belt D70',
      308: 'Golden Belt D80',
      309: 'Golden Belt D90'
    };

    return belts[id] || null;
  }
}

const userService = new UserService();
export default userService;
